import { Component } from '@angular/core';
import { CardComponent } from '@components/card/card.component';

import { OrderCompleteInstructionsConsultationBaseComponent } from '../order-complete-instructions-consultation-base/order-complete-instructions-consultation-base.component';

@Component({
  selector: 'app-order-complete-instructions-stallion',
  templateUrl:
    '../order-complete-instructions-consultation-base/order-complete-instructions-consultation-base.component.html',
  imports: [CardComponent],
})
export class OrderCompleteInstructionsStallionComponent extends OrderCompleteInstructionsConsultationBaseComponent {
  protected readonly siteName = 'Stallion.com';
}
